@if (incomeTaxEntity$ | async) {
  <form [formGroup]="formGroup" (change)="saveForm()">
    <div>
      @if (onverrekendeVerliezenBox1.length > 0) {
        <div formArrayName="onverrekendeVerliezenBox1">
          @for (item of onverrekendeVerliezenBox1.controls; track item; let i = $index) {
            <div [formGroupName]="i">
              <div class="row col-auto" style="--bs-gutter-x: 0.5rem;">
                <snelstart-ui-select-form-control [label]="i === 0 ? 'Verlies box 1' : ''"
                                                  [options]="optionsJarenBox1"
                                                  [required]=true
                                                  class="custom-input-250"
                                                  formControlName="omschrijving"
                                                  id="verliesBox1"
                >
                </snelstart-ui-select-form-control>
                <snelstart-ui-number-form-control [label]="i === 0 ? 'Bedrag' : ''"
                                                  [decimals]="0"
                                                  class="custom-input-150"
                                                  align="right"
                                                  formControlName="bedrag"
                                                  id="bedragBox1"
                                                  prefix="€"
                >
                </snelstart-ui-number-form-control>
                <snelstart-ui-button (click)="verwijderRijVerliesBox1(i)"
                                     [class]="i === 0 ? 'firstrowbutton col-auto ' : 'col-auto '"
                                     class="delete"
                                     icon="trash"
                                     id="buttonDeleteBox1"
                                     size="medium"
                                     type="secondary"
                >
                </snelstart-ui-button>
              </div>
            </div>
          }
        </div>
      }
      <snelstart-ui-button (click)="addRijVerliesBox1()" class="snelstart-ui-button pb-3" icon="plus"
                           type="link">Onverrekende verliezen box 1 toevoegen
      </snelstart-ui-button>
    </div>

    <div>
      @if (onverrekendeVerliezenBox2.length > 0) {
        <div formArrayName="onverrekendeVerliezenBox2">
          @for (item of onverrekendeVerliezenBox2.controls; track item; let i = $index) {
            <div [formGroupName]="i">
              <div class="row col-auto" style="--bs-gutter-x: 0.5rem;">
                <snelstart-ui-select-form-control [label]="i === 0 ? 'Verlies box 2' : ''"
                                                  [options]="optionsJarenBox1"
                                                  [required]=true
                                                  class="custom-input-250"
                                                  formControlName="omschrijving"
                                                  id="verliesBox1"
                >
                </snelstart-ui-select-form-control>
                <snelstart-ui-number-form-control [label]="i === 0 ? 'Bedrag' : ''"
                                                  [decimals]="0"
                                                  class="custom-input-150"
                                                  align="right"
                                                  formControlName="bedrag"
                                                  id="bedragBox1"
                                                  prefix="€"
                >
                </snelstart-ui-number-form-control>
                <snelstart-ui-button (click)="verwijderRijVerliesBox2(i)"
                                     [class]="i === 0 ? 'firstrowbutton col-auto ' : 'col-auto '"
                                     class="delete"
                                     icon="trash"
                                     id="buttonDeleteBox1"
                                     size="medium"
                                     type="secondary"
                >
                </snelstart-ui-button>
              </div>
            </div>
          }
        </div>
      }
      <snelstart-ui-button (click)="addRijVerliesBox2()" class="snelstart-ui-button pb-3" icon="plus"
                           type="link">Onverrekende verliezen box 2 toevoegen
      </snelstart-ui-button>
    </div>

    <div>
      @if (belastingkortingBox2.length > 0) {
        <div formArrayName="belastingkortingBox2">
          @for (item of belastingkortingBox2.controls; track item; let i = $index) {
            <div [formGroupName]="i">
              <div class="row col-auto" style="--bs-gutter-x: 0.5rem;">
                <snelstart-ui-select-form-control [label]="i === 0 ? 'Belastingkorting box 2' : ''"
                                                  [options]="optionsJarenBox1"
                                                  [required]=true
                                                  class="custom-input-250"
                                                  formControlName="omschrijving"
                                                  id="verliesBox1"
                >
                </snelstart-ui-select-form-control>
                <snelstart-ui-number-form-control [label]="i === 0 ? 'Bedrag' : ''"
                                                  [decimals]="0"
                                                  class="custom-input-150"
                                                  align="right"
                                                  formControlName="bedrag"
                                                  id="bedragBox1"
                                                  prefix="€"
                >
                </snelstart-ui-number-form-control>
                <snelstart-ui-button (click)="verwijderRijBelastingkortingBox2(i)"
                                     [class]="i === 0 ? 'firstrowbutton col-auto ' : 'col-auto '"
                                     class="delete"
                                     icon="trash"
                                     id="buttonDeleteBox1"
                                     size="medium"
                                     type="secondary"
                >
                </snelstart-ui-button>
              </div>
            </div>
          }
        </div>
      }
      <snelstart-ui-button (click)="addRijBelastingkortingBox2()" class="snelstart-ui-button pb-3" icon="plus"
                           type="link">Belastingkorting box 2 toevoegen
      </snelstart-ui-button>
    </div>

    <div>
      @if (onverrekendeBuitenlandseBronheffing.length > 0) {
        <div formArrayName="onverrekendeBuitenlandseBronheffing">
          @for (item of onverrekendeBuitenlandseBronheffing.controls; track item; let i = $index) {
            <div [formGroupName]="i">
              <div class="row col-auto" style="--bs-gutter-x: 0.5rem;">
                <snelstart-ui-select-form-control [label]="i === 0 ? 'Omschrijving' : ''"
                                                  [options]="optionsJarenBox1"
                                                  [required]=true
                                                  class="custom-input-250"
                                                  formControlName="omschrijving"
                                                  id="verliesBox1"
                >
                </snelstart-ui-select-form-control>
                <snelstart-ui-number-form-control [label]="i === 0 ? 'Bedrag' : ''"
                                                  [decimals]="0"
                                                  class="custom-input-150"
                                                  align="right"
                                                  formControlName="bedrag"
                                                  id="bedragBox1"
                                                  prefix="€"
                >
                </snelstart-ui-number-form-control>
                <snelstart-ui-button (click)="verwijderRijOnverrekendeBuitenlandseBronheffing(i)"
                                     [class]="i === 0 ? 'firstrowbutton col-auto ' : 'col-auto '"
                                     class="delete"
                                     icon="trash"
                                     id="buttonDeleteBox1"
                                     size="medium"
                                     type="secondary"
                >
                </snelstart-ui-button>
              </div>
            </div>
          }
        </div>
      }
      <snelstart-ui-button (click)="addRijOnverrekendeBuitenlandseBronheffing()" class="snelstart-ui-button" icon="plus"
                           type="link">Buitenlandse bron-/dividendbelasting toevoegen
      </snelstart-ui-button>
    </div>
  </form>
}
